<template>
  <div class="donate-container">
    <iframe
      src="https://donorbox.org/embed/greatcommissionnow-org-1?default_interval=m"
      name="donorbox"
      allowpaymentrequest=""
      seamless="seamless"
      frameborder="0"
      scrolling="no"
      height="700px"
      width="100%"
      style="max-width: 500px; min-width: 250px; max-height: none !important;"
    ></iframe>
  </div>
</template>
<script>
export default {
  mounted() {
    if (!document.getElementById('donateEmbed')) {
      const script = document.createElement('script');
      script.paypalExpress = 'true';
      script.src = 'https://donorbox.org/widget.js';
      script.id = 'donateEmbed';
      document.head.appendChild(script);
    }
  },
};
</script>
<style lang="scss">
.donate-container {
  margin-top: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
